var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"A double quote icon"),React.createElement("path",{"d":"m15 .00015c1.6575 0 3 1.3425 3 3v18c0 1.656-1.3425 3-3 3h-12c-1.6575 0-3-1.344-3-3v-18c0-1.6575 1.3425-3 3-3zm0 1.5h-12c-.8265 0-1.5.6735-1.5 1.5v18c0 .8265.6735 1.5 1.5 1.5h12c.8265 0 1.5-.6735 1.5-1.5v-18c0-.8265-.6735-1.5-1.5-1.5zm-6.75 15c.4125 0 .75.3375.75.75s-.3375.75-.75.75h-3c-.4125 0-.75-.3375-.75-.75s.3375-.75.75-.75zm4.5-5.25c.4125 0 .75.3375.75.75s-.3375.75-.75.75h-7.5c-.4125 0-.75-.3375-.75-.75s.3375-.75.75-.75zm0-5.25c.4125 0 .75.3375.75.75s-.3375.75-.75.75h-7.5c-.4125 0-.75-.3375-.75-.75s.3375-.75.75-.75z","fill":"#fff","fillRule":"evenodd","key":1})]);
}

Quote.defaultProps = {"height":"24","viewBox":"0 0 18 24","width":"18"};

module.exports = Quote;

Quote.default = Quote;
